import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Lesson} from '@models/lesson';
import {Curriculum} from '@models/curriculum';
import {Router} from '@node_modules/@angular/router';
import {ActionTypes} from '@store/program/actions';
import {Store} from '@node_modules/@ngrx/store';
import * as ProgramReducer from '@store/program/reducers';
import {CurriculumPageComponent} from '@pages/layout/curriculum/curriculum-page/curriculum-page.component';
import {Program} from '@models/program';
import * as AuthReducer from '@store/auth/reducers';
import {User} from '@models/user';
import {ScheduleFacade} from '@facades/schedule/scheduleFacade';
import * as moment from 'moment';

@Component({
  selector: 'app-view-curriculum',
  templateUrl: './view-curriculum.component.html',
  styleUrls: ['./view-curriculum.component.scss']
})
export class ViewCurriculumComponent implements OnInit, OnDestroy {
  static source = 'admin';
  static onlyLesson = true;
  static curriculum: Curriculum;
  static schoolLogo: string;
  static program: Program;
  static initLesson: Lesson;
  static onlyDescription = false;
  static modalRef;
  static initClass;
  static fullContent = true;
  currentLesson: Lesson;
  currentCurriculum: Curriculum;
  currentSchoolLogo: string;
  curriculums: Curriculum[];
  lessons: Lesson[];
  isEditing = false;
  subscribes = [];
  user: User;
  splitByProjects = {};
  currentClass;
  onlyDescription;

  constructor(
    private router: Router,
    private programStore: Store<ProgramReducer.ProgramState>,
    private authStore: Store<AuthReducer.AuthState>,
  ) { }

  ngOnInit() {
    if (ViewCurriculumComponent.fullContent) {
      document.querySelector('body').classList.add('pop-up-curriculums');
    }
    if (ViewCurriculumComponent.curriculum) {
      this.currentCurriculum = ViewCurriculumComponent.curriculum;
      this.lessons = ViewCurriculumComponent.curriculum.lessons;
    }
    if (ViewCurriculumComponent.schoolLogo) {
      this.currentSchoolLogo = ViewCurriculumComponent.schoolLogo;
    }
    if (ViewCurriculumComponent.initLesson) {
      this.currentLesson = ViewCurriculumComponent.initLesson;
      console.log(this.currentLesson);
    }
    if (ViewCurriculumComponent.initClass) {
      this.currentClass = ViewCurriculumComponent.initClass;
    }
    this.onlyDescription = ViewCurriculumComponent.onlyDescription;
    this.subscribes.push(this.programStore.subscribe(
      (val) => {
        if (val &&  val.program) {
          const programs = val.program;
          // console.log(ActionTypes.SET_CURRICULUM);
          if (programs.lastAction === ActionTypes.SET_CURRICULUM) {
            this.isEditing = false;
          }
        }
      }
    ));
    this.subscribes.push(this.authStore.subscribe(
        (val) => {
          const auth = val.auth;
          if (auth && auth.user) {
            this.user = auth.user;
            console.log(this);
            if (this.user.role !== 'admin') {
              auth.user.yearAttendanceFromApi.map( attendance => {
                if (!this.splitByProjects[attendance.program_id]) {
                  this.splitByProjects[attendance.program_id] = {};
                }
                if (!this.splitByProjects[attendance.program_id][attendance.curriculum_id]) {
                  this.splitByProjects[attendance.program_id][attendance.curriculum_id] = {};
                }
                if (!this.splitByProjects[attendance.program_id][attendance.curriculum_id][attendance.lesson_id]) {
                  this.splitByProjects[attendance.program_id][attendance.curriculum_id][attendance.lesson_id] = [];
                }
                this.splitByProjects[attendance.program_id][attendance.curriculum_id][attendance.lesson_id].push(attendance.lesson_id);
              });
            }
          }
        }
    ));
  }
  koko(one, two) {
    console.log(one, two);
  }
  getTime(time) {
    let ts = time.format('HH:mm');
    const H = +ts.substr(0, 2);
    const h = (H % 12) || 12;
    const ampm = H < 12 ? ' AM' : ' PM';
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }
  mouseover(event) {
    event.target.parentElement.classList.add('hover');
  }
  mouseleave(event) {
    event.target.parentElement.classList.remove('hover');
  }
  ngOnDestroy() {
    this.subscribes.map( subsrc => subsrc.unsubscribe());
  }
  onClose(event) {
    event.stopPropagation();
    if (ViewCurriculumComponent.modalRef) {
      ViewCurriculumComponent.modalRef.close();
    }
  }
  toEditPage() {
    CurriculumPageComponent.redirectParams = {
      program_id: ViewCurriculumComponent.program.id,
      tab: 'schedule'
    };
    if (ViewCurriculumComponent.modalRef) {
      ViewCurriculumComponent.modalRef.close();
    }
    this.router.navigate(['/curriculums'], {
      queryParams: {
        page: 'program',
        curriculum_id: ViewCurriculumComponent.curriculum.id,
        lesson_id: ViewCurriculumComponent.initLesson.id,
      }
    });
  }
  isAdmin() {
    return ViewCurriculumComponent.source === 'admin';
  }
  onlyLesson() {
    return ViewCurriculumComponent.onlyLesson;
  }
}
